<template>
  <page class="stay">
    <header-component />
    <section>
      <hero-section />
      <faq type="spaces" />
    </section>
  </page>
</template>

<script>
import Page from "@/shared/page"
import HeaderComponent from "@/features/header/components"
import Faq from "@/features/expendable-faq/expendable-faq"
import HeroSection from "./hero-section"
import { getSearchParam } from "@/utils/location"

export default {
  name: "ConnectFaqPage",
  components: {
    HeaderComponent,
    HeroSection,
    Page,
    Faq
  },
  mounted() {
    if (getSearchParam("webview") === "true") {
      this.removeHeaderAndFooter()
    }
  },
  methods: {
    removeHeaderAndFooter() {
      const header = document.querySelector(".header")
      const footer = document.querySelector(".footer-bottom")
      if (header) {
        header.remove()
      }
      if (footer) {
        footer.remove()
      }
    }
  }
}
</script>

<style lang="scss">
.expendable-faq {
  &__headline {
    @apply text-left m:text-center mb-3;
  }
}
</style>
